import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { BaseSelect } from '../../../custom_shared/components';
import './BaseCompanySwitch.less';

const BaseCompanySwitch: React.FC = () => {
    const { baseCompanySegregationStore, businessSearchStore } = useAppStore();

    if (baseCompanySegregationStore.switchHidden) {
        return null;
    }

    const getClassName = () => {
        let className = 'base-company-switch';

        if (baseCompanySegregationStore.loadingBaseCompanies) {
            className += ' loading';
        }

        if (baseCompanySegregationStore.isSelectionDisabled) {
            className += ' disabled';
        }

        return className;
    };

    const handleCompanyChange = async (selectedBaseCompanyId: string) => {
        await baseCompanySegregationStore.selectBaseCompany(selectedBaseCompanyId);
        await businessSearchStore.getBusinessPartners(true);
    };

    return (
        <BaseSelect
            placeholder="Search base companies..."
            className={getClassName()}
            disabled={baseCompanySegregationStore.isSelectionDisabled}
            loading={baseCompanySegregationStore.loadingBaseCompanies}
            value={baseCompanySegregationStore.state.selectedBaseCompanyId ?? undefined}
            options={baseCompanySegregationStore.baseCompanyOptions}
            filterOption={(text, option) => option?.title && option.title.toLowerCase().includes(text.toLowerCase())}
            onChange={(selectedBaseCompanyId: string) => handleCompanyChange(selectedBaseCompanyId)}
            showSearch
        />
    );
};

export default observer(BaseCompanySwitch);
